import React from 'react';
import BaseComponent from '../BaseComponent';
import PropTypes from 'prop-types';
import DialogBase from "./DialogBase";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "../../../appl/view/components/buttons/Button";

class ConfirmationDialog extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {}
  }

  onConfirmClick = (e) => {
    if (this.props.onConfirmClick) {
      this.props.onConfirmClick(e);
    }
  }

  onCancelClick = (e) => {
    if (this.props.onCancelClick) {
      this.props.onCancelClick(e);
    }
  }

  render() {
    let {
      confirmButtonColor = 'error',
      confirmButtonText = 'Ja',
      showCancelButton = true,
      isOpen = true,
      title,
      isLoading,
      children
    } = this.props;
    return <DialogBase
      open={isOpen}
      title={title}
      onCloseButtonClick={this.onCancelClick}
      actions={<>
        {showCancelButton && <Button
          disabled={isLoading}
          color=''
          variant={'outlined'}
          onClick={this.onCancelClick}>
          Nein
        </Button>}
        <LoadingButton
          color={confirmButtonColor}
          loading={isLoading}
          variant='contained'
          onClick={this.onConfirmClick}>
          {confirmButtonText}
        </LoadingButton>
      </>}>
      {children}
    </DialogBase>;
  }
}

ConfirmationDialog.propTypes = {
  title: PropTypes.string,
  onCancelClick: PropTypes.func,
  isLoading: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  isOpen: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  onConfirmClick: PropTypes.func,
  confirmButtonColor: PropTypes.oneOf(['primary', 'secondary', 'warning', 'error']),
};

export default ConfirmationDialog;
